var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"interaction-data"},[_c('pageTitle',{attrs:{"pageTitle":"互动统计"}}),_c('title-data',{attrs:{"liveDetailInfo":_vm.liveDetailInfo}}),_c('base-data',{attrs:{"isStatus":_vm.liveDetailInfo.webinar_state,"webinarType":_vm.liveDetailInfo.webinar_type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }